import { render, staticRenderFns } from "./InvoiceRevisionHistoryModal.vue?vue&type=template&id=3a9a2120&scoped=true&"
import script from "./InvoiceRevisionHistoryModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceRevisionHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceRevisionHistoryModal.vue?vue&type=style&index=0&id=3a9a2120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9a2120",
  null
  
)

export default component.exports